import { makeStyles } from '@material-ui/core'
import { colors } from '../../../Themes'

const useStyles = makeStyles((theme) => ({
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 15,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      paddingLeft: 0,
    },
  },
  subContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '30px' 
  },
  form: {
    marginBottom: 20,
  },
  inputForm: {
    marginBottom: 10,
    [theme.breakpoints.between('sm', 'lg')]: {
      maxWidth: '550px',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '450px',
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: '750px',
    },
  },
  loaderWrapper: {
    display: 'flex',
    height: '30vh',
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttonDiv: {
    maxWidth: '450px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '60%',
    },
    [theme.breakpoints.between('sm', 'lg')]: {
      maxWidth: '400px',
    },
  },
  cancelButton: {
    width: '100%',
    backgroundColor: colors.primary,
    color: colors.white,
    '&:hover': {
      backgroundColor: colors.white,
      color: colors.primary,
    },
  },
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: '50%',
    border: '1px solid #314155',
    width: 24,
    height: 24,
  },
  checkedIcon: {
    backgroundColor: colors.primary
  },
}))

export default useStyles